module.exports = __webpack_public_path__ + "public/images/logo_otm.ed4f5410ab7a02d81044ff737a7adbe0.svg";